module.exports = __webpack_public_path__ + "img/opdracht-open.79df32a1.png";